import CommonModal from "views/components/CommonModal";
import styles from "./PopBox.module.less";
const PopBox = ({
  leftTitle = "",
  leftOnClick = () => {},
  rightTitle = "",
  rightOnClick = () => {},
  visible,
  topTitle = "",
  content = "",
  bottomOnClick = () => {},
}) => {
  return (
    <CommonModal isOpen={visible}>
      <div className={styles["pop-container"]}>
        <div className={styles["success-pop-wrapper"]}>
          <div className={styles["success-pop-wrapper-title"]}>{topTitle}</div>
          <div className={styles["success-pop-wrapper-text"]}>{content}</div>
          <div className={styles["success-pop-wrapper-button"]}>
            <div
              className={`${styles["button-item"]} ${styles["button-cancel"]}`}
              onClick={() => leftOnClick()}
            >
              {leftTitle}
            </div>
            <div
              className={`${styles["button-item"]} ${styles["button-confirm"]}`}
              onClick={() => rightOnClick()}
            >
              {rightTitle}
            </div>
          </div>
        </div>
        <img
          onClick={() => bottomOnClick()}
          className={styles["modal-close"]}
          src={require("@/images/mine/recommend-officer/button_cancel.png")}
        />
      </div>
    </CommonModal>
  );
};
export default PopBox;
